import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <span className="logo-icon">✈️</span>
            TravelExplorer
          </Link>
          
          <nav className="nav">
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'nav-link-active' : ''}`}
            >
              Accueil
            </Link>
            <Link 
              to="/destinations" 
              className={`nav-link ${location.pathname === '/destinations' ? 'nav-link-active' : ''}`}
            >
              Destinations
            </Link>
            <Link 
              to="/about" 
              className={`nav-link ${location.pathname === '/about' ? 'nav-link-active' : ''}`}
            >
              À propos
            </Link>
            <Link 
              to="/contact" 
              className={`nav-link ${location.pathname === '/contact' ? 'nav-link-active' : ''}`}
            >
              Contact
            </Link>
          </nav>

          {/* Header actions removed because no authentication/DB is available */}
        </div>
      </div>
    </header>
  );
};

export default Header;